import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import EBookPage from './pages/EBookPage';
import PromptGallery from './pages/PromptGallery';
import WebinarSignup from './pages/WebinarSignup';
import TermsofServices from './pages/TermsofServices';
import PrivacyPolicy from './pages/PrivacyPolicy';  
import AdminLayout from './pages/Admin/AdminLayout';
import LoginPage from './pages/Admin/LoginPage';
import AboutMe from './pages/AboutMe';
import AIAgents from './pages/AIAgents';
import Blog from './pages/Blog';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ebook" element={<EBookPage />} />
          <Route path="/prompt-gallery" element={<PromptGallery />} />
          <Route path="/terms" element={<TermsofServices />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about-me" element={<AboutMe />} />
           <Route path="/ai-agents" element={<AIAgents />} />
           <Route path="/blog" element={<Blog />} />
           <Route path="/signup-webinar" element={<WebinarSignup />} />
          <Route path="/admin/dashboard" element={<AdminLayout />} />
          <Route path="/admin/login" element={<LoginPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
